import "../css/header.scss";
import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CartContext } from "../Component/CartContext";
import { FavoritesContext } from "./FavoritesContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faUser,
  faShoppingBag,
} from "@fortawesome/free-solid-svg-icons";
import productData from "../Datas/productData";

function Header() {
  const { cartItems } = useContext(CartContext);
  const { isLoggedIn } = useContext(FavoritesContext);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const searchRef = useRef(null);
  const navigate = useNavigate();

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setIsSearchOpen(false);
    setSearchQuery("");
  };

  const primaryLinks = [
    { label: "Shop", to: "/shop" },
    { label: "About", to: "/about" },
    { label: "Contact", to: "/contact" },
  ];

  const bagCount = Array.isArray(cartItems) ? cartItems.length : 0;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsSearchOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    // Remove the instant search logic here
    if (isSearchOpen) {
      setIsSearchOpen(false);
    }
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const filteredProducts = productData.filter((product) =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setSearchResults(filteredProducts);
      setIsSearchOpen(true);
    } else {
      setSearchResults([]);
      setIsSearchOpen(false);
    }
  };

  const isVideo = (url) => /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);

  return (
    <header>
      <div className="header-container">
        <nav className="header-left">
          {primaryLinks.map(({ label, to }) => (
            <Link key={label} to={to} onClick={toTop}>
              {label}
            </Link>
          ))}
        </nav>
        <div className="header-center">
          <Link to="/" onClick={toTop}>
            Mangoes
          </Link>
        </div>
        <nav className="header-right">
          <div className="header-search-container" ref={searchRef}>
            <form className="header-search" onSubmit={handleSearchSubmit}>
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={handleSearchChange}
                className="header-search__input"
              />
              <button
                type="submit"
                className="header-search__button"
                aria-label="Search"
              >
                <FontAwesomeIcon icon={faSearch} />
              </button>
            </form>

            {isSearchOpen && (
              <div className="search-dropdown">
                {searchResults.length > 0 ? (
                  <ul className="search-results-list">
                    {searchResults.map((product) => {
                      const primaryImage = product.images?.[0];
                      return (
                        <li key={product.id} className="search-result-item">
                          <Link
                            to={`/shopDetails/${product.id}`}
                            onClick={toTop}
                          >
                            <div className="search-result-image">
                              {primaryImage &&
                                (isVideo(primaryImage) ? (
                                  <video
                                    src={primaryImage}
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                  />
                                ) : (
                                  <img src={primaryImage} alt={product.name} />
                                ))}
                            </div>
                            <div className="search-result-info">
                              <p className="search-result-name">
                                {product.name}
                              </p>
                              <p className="search-result-price">
                                € {product.price}
                              </p>
                            </div>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <div className="search-no-results">
                    <p>No products found for "{searchQuery}"</p>
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="header-user-container">
            <Link
              to={isLoggedIn ? "/profile" : "/login"}
              className="header-icon-link"
              aria-label="User Account"
              onClick={toTop}
            >
              <FontAwesomeIcon icon={faUser} />
            </Link>
          </div>

          <Link
            to="/cartpage"
            className="header-icon-link header-cart-link"
            onClick={toTop}
            aria-label="Shopping Bag"
          >
            <FontAwesomeIcon icon={faShoppingBag} />
            {bagCount > 0 && (
              <span className="header-cart-count">{bagCount}</span>
            )}
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
